export default "__VITE_ASSET__70bd020b__"